import React, { useState } from 'react'
import { Button, Form, Modal, Pagination, Table } from 'react-bootstrap'
import { getValue } from '../../utils/getValue'
import './produtos.css'

const getColorClass = (descricao) => {
  const primeiraLetra = descricao.charAt(0).toUpperCase()
  if (primeiraLetra === 'S') {
    return 'Saida'
  } else if (primeiraLetra === 'E') {
    return 'Entrada'
  } else if (primeiraLetra === 'B') {
    return 'Balanço'
  } else if (primeiraLetra === 'C') {
    return 'CallBack'
  }
  return ''
}

const getColor = (descricao) => {
  const primeiraLetra = descricao.charAt(0).toUpperCase()
  if (primeiraLetra === 'S') {
    return 'text-danger'
  } else if (primeiraLetra === 'E') {
    return 'text-success'
  } else if (primeiraLetra === 'B') {
    return 'text-info'
  } else if (primeiraLetra === 'C') {
    return 'text-success'
  }
  return ''
}

const MovimentacaoEstoqueModal = ({
  produto,
  showModal,
  handleClose,
  historico,
}) => {
  const [filtro, setFiltro] = useState('Todos')
  const [paginaAtual, setPaginaAtual] = useState(1)
  const itensPorPagina = 50

  const historicoFiltrado =
    filtro === 'Todos'
      ? historico
      : historico.filter(
          (movimentacao) => getColorClass(movimentacao.DESCRICAO) === filtro,
        )

  const indiceInicial = (paginaAtual - 1) * itensPorPagina
  const indiceFinal = indiceInicial + itensPorPagina
  const historicoPaginado = historicoFiltrado.slice(indiceInicial, indiceFinal)

  const totalPaginas = Math.ceil(historicoFiltrado.length / itensPorPagina)

  const mudarPagina = (novaPagina) => {
    if (novaPagina > 0 && novaPagina <= totalPaginas) {
      setPaginaAtual(novaPagina)
    }
  }

  const renderizarPaginas = () => {
    const paginasVisiveis = 5 // Número máximo de botões exibidos
    const paginas = []

    let start = Math.max(paginaAtual - Math.floor(paginasVisiveis / 2), 1)
    let end = Math.min(start + paginasVisiveis - 1, totalPaginas)

    if (end - start + 1 < paginasVisiveis) {
      start = Math.max(end - paginasVisiveis + 1, 1)
    }

    for (let i = start; i <= end; i++) {
      paginas.push(
        <Pagination.Item
          key={i}
          active={paginaAtual === i}
          onClick={() => mudarPagina(i)}
        >
          {i}
        </Pagination.Item>,
      )
    }

    return paginas
  }

  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      dialogClassName="custom-modalzpl"
    >
      <Modal.Header closeButton>
        <Modal.Title>Histórico de Movimentações - {produto.nome}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="filtroTipo">
          <Form.Label>Filtrar por Tipo:</Form.Label>
          <Form.Control
            as="select"
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
            style={{ fontSize: '12px' }}
          >
            <option value="Todos">Todos</option>
            <option value="Saida">Saída</option>
            <option value="Entrada">Entrada</option>
            <option value="Balanço">Balanço</option>
            <option value="CallBack">CallBack</option>
          </Form.Control>
        </Form.Group>

        {historicoPaginado.length > 0 ? (
          <Table
            striped
            bordered
            hover
          >
            <thead>
              <tr>
                <th
                  className="text-secondary"
                  style={{ fontSize: '12px' }}
                >
                  Origem
                </th>
                <th
                  className="text-secondary"
                  style={{ fontSize: '12px' }}
                >
                  Cliente
                </th>
                <th
                  className="text-secondary"
                  style={{ fontSize: '12px' }}
                >
                  Valor
                </th>
                <th
                  className="text-secondary"
                  style={{ fontSize: '12px' }}
                >
                  Quantidade
                </th>
                <th
                  className="text-secondary"
                  style={{ fontSize: '12px' }}
                >
                  Saldo anterior
                </th>
                <th
                  className="text-secondary"
                  style={{ fontSize: '12px' }}
                >
                  Tipo
                </th>
                <th
                  className="text-secondary"
                  style={{ fontSize: '12px' }}
                >
                  Data
                </th>
              </tr>
            </thead>
            <tbody>
              {historicoPaginado.map((movimentacao, index) => (
                <tr key={index}>
                  <td style={{ fontSize: '12px' }}>{movimentacao.ORIGEM}</td>
                  <td style={{ fontSize: '12px' }}>{movimentacao.CLIENTE}</td>
                  <td style={{ fontSize: '12px' }}>
                    {
                      movimentacao.ORIGEM === 'Callback Estoque'
                        ? 'movimentação de estoque bling'
                        : localStorage.getItem('admin') === 'SIM'
                          ? movimentacao.CUSTO !== null
                            ? `R$ ${movimentacao.CUSTO.toFixed(2)} (Custo)`
                            : '-'
                          : '' // Não mostra nada se não for admin
                    }
                  </td>

                  <td
                    style={{ fontSize: '12px' }}
                    className={getColor(movimentacao.DESCRICAO)}
                  >
                    {movimentacao.QUANTIDADE !== null
                      ? (getColorClass(movimentacao.DESCRICAO) === 'Saida'
                          ? '-'
                          : '') + movimentacao.QUANTIDADE.toFixed(2)
                      : '0.00'}
                  </td>
                  <td style={{ fontSize: '12px' }}>
                    {movimentacao.SALDO_ESTOQUE != null
                      ? movimentacao.SALDO_ESTOQUE.toFixed(2)
                      : 'Não há dados disponíveis'}
                  </td>
                  <td
                    style={{ fontSize: '12px' }}
                    className={getColor(movimentacao.DESCRICAO)}
                  >
                    {getColorClass(movimentacao.DESCRICAO)}
                  </td>
                  <td style={{ fontSize: '12px' }}>
                    {movimentacao.DATA
                      ? new Date(movimentacao.DATA).toLocaleDateString('pt-BR')
                      : '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <p>Nenhuma movimentação registrada.</p>
        )}

        {totalPaginas > 1 && (
          <Pagination>
            <Pagination.First
              onClick={() => mudarPagina(1)}
              disabled={paginaAtual === 1}
            />
            <Pagination.Prev
              onClick={() => mudarPagina(paginaAtual - 1)}
              disabled={paginaAtual === 1}
            />
            {renderizarPaginas()}
            <Pagination.Next
              onClick={() => mudarPagina(paginaAtual + 1)}
              disabled={paginaAtual === totalPaginas}
            />
            <Pagination.Last
              onClick={() => mudarPagina(totalPaginas)}
              disabled={paginaAtual === totalPaginas}
            />
          </Pagination>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={handleClose}
        >
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default MovimentacaoEstoqueModal
